/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import PrivacyPolicy from "views/examples/PrivacyPolicy.js";
import TermsOfService from "views/examples/TermsOfService.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import ProvincesList from "views/content/ProvincesList.js";
import DealsList from "views/content/DealsList.js";
import RequireAuth from "components/Auth/RequireAuth.js";
import LegendEdit from "views/content/LegendEdit";

var routes = [
  {
    path: "/index",
    name: "Karadeniz Destinasyonu",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
  },
  {
    path: "/content/provinces",
    name: "DBS Provinces",
    icon: "ni ni-map-big text-info",
    component: <ProvincesList />,
    layout: "/admin",
  },
  {
    path: "/content/deals",
    name: "DBS Deals",
    icon: "ni ni-tag text-primary",
    component: <DealsList />,
    layout: "/admin",
  },
  {
    path: "/content/legends/new",
    name: "Yeni Efsane Ekle",
    icon: "ni ni-fat-add text-primary",
    component: <LegendEdit />,
    layout: "/admin",
  },
  {
    path: "/icons",
    name: "Icons",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "ni ni-pin-3 text-orange",
    component: <Maps />,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: (
      <RequireAuth>
        <Profile />
      </RequireAuth>
    ),
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Tables",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
  },
  {
    path: "/privacy-policy",
    name: "Gizlilik Politikası",
    icon: "ni ni-lock-circle-open text-info",
    component: <PrivacyPolicy />,
    layout: "/auth",
  },
  {
    path: "/terms-of-service",
    name: "Üyelik Hizmet Şartları",
    icon: "ni ni-single-copy-04 text-info",
    component: <TermsOfService />,
    layout: "/auth",
  },
];
export default routes;
